import { DateTime } from 'luxon'
import React from 'react'

import KpiItem from '../../Layout/Common/KpiItem'

function WebsiteScoreKpi({ pageMetrics, type, prevMetrics, showSparkLine, visualComponent, abbreviate }){
    let avgPerfScore = 0
    let plottedItems = []
    let prevValue = 0

    pageMetrics.forEach((item,key) => {
        plottedItems.push({
            x: DateTime.fromISO(item.date).toFormat("LL-dd"),
            y: (item.metrics[type].performanceScore * 100).toFixed(0)
        })

        avgPerfScore += item.metrics[type].performanceScore
    });

    if(prevMetrics) {
        prevMetrics?.forEach(m => {
            prevValue += m.metrics[type].performanceScore
        })
    }
    
    if(pageMetrics.length > 0){
        avgPerfScore /= pageMetrics.length
    }
    let valueClasses = "text-success"

    if(avgPerfScore !== 0 && avgPerfScore >= 0.5 && avgPerfScore < 0.90){
        valueClasses = "text-warning"
    } else if(avgPerfScore !== 0 && avgPerfScore < 0.5){
        valueClasses = "text-danger"
    }

    const kpiItem = {
        title: `${type} ${abbreviate ? "PERF" : "PERFORMANCE"}`, 
        value: (avgPerfScore !== 0 ? (avgPerfScore * 100).toFixed(0) : 0), 
        valueClasses,
        visualComponent,
        plottedItems: showSparkLine ? [{
            data: plottedItems
        }] : [], 
        description: (<div>
            <p>The Performance Score is a summary of five performance metrics. The color-coding maps to these Performance score ranges:</p>

            0 to 49 (slow): <span className="text-danger">Red</span><br />
            50 to 89 (average): <span className="text-warning">Orange</span><br />
            90 to 100 (fast): <span className="text-success">Green</span><br />
            <a href="https://developers.google.com/web/tools/lighthouse/v3/scoring#perf-weighting" target="_blank">Learn more.</a>

        </div>)
    }

    if(prevValue > 0){
        kpiItem.prevValue = (prevValue / prevMetrics.length * 100).toFixed(0)
    }

    return <KpiItem {...kpiItem} />
}

WebsiteScoreKpi.defaultProps = {
    type: "MOBILE",
    prevMetrics: [],
    showSparkLine: true,
    abbreviate: false
}

export default WebsiteScoreKpi